import React from 'react';
import Close from '@assets/images/close.svg';
interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
  }
const Modal: React.FC<ModalProps> = ({ isOpen, onClose }) => {
    if (!isOpen) {
        return null;
      }

  return (
    <div>

      {/* Modal Backdrop */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          {/* Modal Container */}
          <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4">
            {/* Modal Header */}
            <div className="flex justify-end mb-2">
              <img src={Close} alt="Close" onClick={onClose} style={{ cursor: 'pointer' }} width={20}/>
            </div>

            {/* Modal Content */}
            <div className="mb-4">
              <p className='text-left text-sm leading-6 font-normal italic'>
              Cette carte fournit, par région administrative, les volumes cumulés de puissance allouée sur le réseau public de transport d’électricité en vue du raccordement de projets d’installations de production, de consommation et de stockage d’électricité.
              </p>
              <p className='text-left text-sm leading-6 font-normal italic'>
              Seuls les projets d’installation ayant valablement accepté une « proposition technique et financière » de la part de RTE à la date de mise à jour de la carte sont compatibilisés. D’autres projets d’installation peuvent être en cours d’étude.
              </p>
              <p className='text-left text-sm leading-6 font-normal italic'>
              La puissance ainsi allouée est prise en compte lorsque RTE étudie les possibilités de raccordement de nouveaux projets d’installation.
              Cette carte n’intègre pas les projets ayant vocation à se raccorder sur les réseaux publics de distribution.</p>
              <p className='text-left text-sm leading-6 font-normal italic'>
              Pour des raisons de secret statistique, certaines valeurs peuvent être masquées.
              Pour mémoire, au 31/12/2024, la puissance de production installée en France s’élève à environ 153 GW.</p> 
              <p className='text-left text-sm leading-6 font-normal italic'>
              La puissance appelée en consommation a varié en 2024 entre 30 et 84 GW, selon l’heure et la saison.
              </p>
            </div>

          </div>
        </div>
      )}
    </div>
  );
};

export default Modal;